import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { AllocationViewEndpoint } from '../constants';
import { AllocationViewSlotBriefModel } from '../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AllocationViewSlotBriefService {
  constructor(private http: WrapperHttpService) {}

  getSlotBrief(compartmentId: number, slotId: number): Observable<AllocationViewSlotBriefModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Slot}${AllocationViewEndpoint.Details}${
      AllocationViewEndpoint.Brief
    }?${getQueryStringFromObject({
      compartmentId,
      slotId,
    })}`;

    return this.http.withLoading().get(url);
  }
}
